import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=0a5b3fbc&scoped=true"
import script from "./GoodsItem.vue?vue&type=script&lang=js"
export * from "./GoodsItem.vue?vue&type=script&lang=js"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&id=0a5b3fbc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b3fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5b3fbc')) {
      api.createRecord('0a5b3fbc', component.options)
    } else {
      api.reload('0a5b3fbc', component.options)
    }
    module.hot.accept("./GoodsItem.vue?vue&type=template&id=0a5b3fbc&scoped=true", function () {
      api.rerender('0a5b3fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Goods/GoodsItem.vue"
export default component.exports